<template>
  <transition :name="transition">
    <keep-alive>
      <router-view :key="$route.path"/>
    </keep-alive>
  </transition>
</template>

<script>
  export default {
    name: 'jason-vue-navigation',
    props: {
      transition: String
    }
  };
</script>